// extracted by mini-css-extract-plugin
export default {"qrColor":"#362044","masterPlanPage":"master-plan-portal-page_masterPlanPage__Hi1jQ","help":"master-plan-portal-page_help__O2JRy"};